import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ALL_TAB, Dashboard, FAVORITES_TAB } from '@/features/resources/Dashboard';

export const Route = createFileRoute('/_authed/favorites')({
  component: FavoritesPage,
});

function FavoritesPage() {
  const navigate = useNavigate();

  return (
    <Dashboard
      activeTab={FAVORITES_TAB}
      setActiveTab={(next) => {
        // Switching tabs from /favorites takes the user to /resources.
        void navigate({
          to: '/resources',
          search: { tab: next === ALL_TAB ? undefined : next },
        });
      }}
    />
  );
}
